// @flow
import React, { PureComponent } from 'react';
import SocialCardNavigator from 'components/social/SocialCardNavigator';
import type { SocialContent } from 'types/SocialContent';
import { STATUS_SUCCESS } from 'constants/statusConstants';
import LazyLoad from 'components/fragments/LazyLoad';
import { Link } from 'react-router-dom';
import { handleTagEvent } from 'utils/tagManagerUtils';
import type { liensRsType } from 'types/Settings';
import type { FullUserType } from 'types/User';

export type StateProps = {
  status: string,
  posts: SocialContent[],
  titleLigue: string,
  liens_rs: liensRsType,
  userPref: FullUserType
};

export type DispatchProps = {
  fetchInstagramPosts: () => void,
  fetchFacebookPosts: () => void,
  fetchTwitterPosts: () => void
};

type Props = StateProps & DispatchProps;

class SocialHub extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchInstagramPosts();
    this.props.fetchFacebookPosts();
    this.props.fetchTwitterPosts();
  }

  render() {
    const {
      liens_rs: {
        fb_lien,
        twitter_lien,
        instagram_lien,
        youtube_lien,
        linkedin_lien,
        twitch_lien,
        snapchat_lien,
        tik_tok_lien,
        x_lien,
        discord_lien
      },
      userPref
    } = this.props;

    if (!this.props.posts.length) {
      return null;
    }

    if (
      fb_lien === '' &&
      twitter_lien === '' &&
      x_lien === '' &&
      instagram_lien === '' &&
      youtube_lien === '' &&
      linkedin_lien === '' &&
      twitch_lien === '' &&
      snapchat_lien === '' &&
      tik_tok_lien === '' &&
      discord_lien === ''
    ) {
      return null;
    }
    return (
      <section className="section section-blue live-feed">
        <LazyLoad isBlue>
          <div className="container">
            <div className="row">
              <div className="col col-md-4 col-lg-3">
                <h2 className="live-feed__title mb-2">Suivez l’actualité en direct.</h2>
                <p className="live-feed__desc ft-secondary mb-4">
                  Retrouvez toute l’actualité de la fédération sur les réseaux sociaux.
                </p>
                <p className="mb-4">
                  {fb_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={fb_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Facebook de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', `facebook`, userPref)}
                    >
                      <i className="icon icon-facebook" />
                    </a>
                  )}
                  {(twitter_lien !== '' || x_lien !== '') && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={twitter_lien || x_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page X de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', `x`, userPref)}
                    >
                      <i className="icon icon-twitter" />
                    </a>
                  )}
                  {instagram_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={instagram_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Instagram de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', `instagram`, userPref)}
                    >
                      <i className="icon icon-instagram" />
                    </a>
                  )}
                  {youtube_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={youtube_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Youtube de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', `youtube`, userPref)}
                    >
                      <i className="icon icon-youtube" />
                    </a>
                  )}
                  {linkedin_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={linkedin_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Linkedin de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', `linkedin`, userPref)}
                    >
                      <i className="icon icon-linkedin" />
                    </a>
                  )}
                  {twitch_lien !== '' && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={twitch_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Twitch de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('social wall', 'suivre reseau social', `twitch`, userPref)}
                    >
                      <i className="icon icon-twitch" />
                    </a>
                  )}
                  {snapchat_lien && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={snapchat_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Snaptchat de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('footer', 'clic_icone_sociale', `snapchat`, userPref)}
                    >
                      <i className="icon icon-snapchat" />
                    </a>
                  )}
                  {tik_tok_lien && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={tik_tok_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page TikTok de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('footer', 'clic_icone_sociale', `tik-tok`, userPref)}
                    >
                      <i className="icon icon-tik-tok" />
                    </a>
                  )}
                  {discord_lien && (
                    <a
                      className="link-icon is-dark mb-2"
                      href={discord_lien}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={`Se rendre sur la page Discord de ${this.props.titleLigue}`}
                      onClick={handleTagEvent('footer', 'clic_icone_sociale', `discord`, userPref)}
                    >
                      <i className="icon icon-discord" />
                    </a>
                  )}
                </p>
              </div>
              {this.props.posts.length > 0 && (
                <SocialCardNavigator
                  liensRs={this.props.liens_rs}
                  socialCards={this.props.posts}
                  showCards={this.props.status === STATUS_SUCCESS}
                />
              )}
            </div>
            {this.props.posts.length > 0 && (
              <div className="row">
                <div className="col col-md-4 col-lg-3">
                  <Link to="/social-wall" className="btn btn--primary">
                    <i className="icon icon-publications is-inline" />
                    <span>Voir les publications</span>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </LazyLoad>
      </section>
    );
  }
}

export default SocialHub;
